// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class ParameterizedQuotePolicyThreshold {
  readonly kind: Enums.QuotePolicyThresholdKindShort;
  readonly productCategory: Enums.ProductCategory;
  readonly productAggregationKind: Enums.QuotePolicyThresholdProductAggregationKind;
  readonly comparator: Enums.Comparator;
  readonly description: string;
  readonly thresholdValue: string;

  constructor(data: { [key: string]: any } = {}) {
    this.kind =
      data.kind === undefined ? Enums.QuotePolicyThresholdKindShort.MarginPercent : data.kind;
    this.productCategory =
      data.productCategory === undefined ? Enums.ProductCategory.ReadyMix : data.productCategory;
    this.productAggregationKind =
      data.productAggregationKind === undefined
        ? Enums.QuotePolicyThresholdProductAggregationKind.LineItem
        : data.productAggregationKind;
    this.comparator = data.comparator === undefined ? Enums.Comparator.Lt : data.comparator;
    this.description = data.description === undefined ? '' : data.description;
    this.thresholdValue = data.thresholdValue === undefined ? '0' : data.thresholdValue;
  }

  static zero(): ParameterizedQuotePolicyThreshold {
    const zeroValues: ExcludeMethodsDeep<ParameterizedQuotePolicyThreshold> = {
      kind: Enums.QuotePolicyThresholdKindShort.MarginPercent,
      productCategory: Enums.ProductCategory.ReadyMix,
      productAggregationKind: Enums.QuotePolicyThresholdProductAggregationKind.LineItem,
      comparator: Enums.Comparator.Lt,
      description: '',
      thresholdValue: '0',
    };
    return new ParameterizedQuotePolicyThreshold(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ParameterizedQuotePolicyThresholdWireFormat = {
  kind: string;
  productCategory: string;
  productAggregationKind: string;
  comparator: string;
  description: string;
  thresholdValue: string;
};

type NewParameterizedQuotePolicyThresholdProps = PartialDeep<
  ParameterizedQuotePolicyThreshold,
  { recurseIntoArrays: true }
>;
export const NewParameterizedQuotePolicyThreshold: (
  props: NewParameterizedQuotePolicyThresholdProps,
) => ParameterizedQuotePolicyThreshold = (props) => new ParameterizedQuotePolicyThreshold(props);

type NewParameterizedQuotePolicyThresholdFromWireFormatProps = PartialDeep<
  ParameterizedQuotePolicyThresholdWireFormat,
  { recurseIntoArrays: true }
>;
export const NewParameterizedQuotePolicyThresholdFromWireFormat: (
  props: NewParameterizedQuotePolicyThresholdFromWireFormatProps,
) => ParameterizedQuotePolicyThreshold = (props) => new ParameterizedQuotePolicyThreshold(props);
